import { ApplicationDevelopmentServicesComponent } from "../application-development-services/application-development-services.component";
import { DataAnalyticServicesComponent } from "../data-analytic-services/data-analytic-services.component";
import { MobileAppsServicesComponent } from "../mobile-apps-services/mobile-apps-services.component";
import { OffshoreDevelopmentServicesComponent } from "../offshore-development-services/offshore-development-services.component";
import { SEODigitalMarketingServicesComponent } from "../seodigital-marketing-services/seodigital-marketing-services.component";
import { TestingServicesComponent } from "../testing-services/testing-services.component";
import { WebDevelopmentServicesComponent } from "../web-development-services/web-development-services.component";

const ipVariable = "https://www.spsoftglobal.com";

export const seoContent = {
    main: {
        url: `${ipVariable}`,
        title: "SPSoft: IT Services Company | AWS Certified Partner | Gen AI",
        description: "AWS Certified Partner providing Generative AI, Data Analytics & AI/ML Solutions, App development, Mobile apps, Data Engineering, Cloud Solutions, Web dev, SEO, and Testing."
    },
    bankingService: {
        url: `${ipVariable}/banking-service`,
        title: "Banking & Financial IT Services and Solutions - SPSoft",
        description: "We offer expertise in the Banking and Finance industry, the development of Instant Payment methods, EFT systems, EMT services, and Flexible Bill Payment services"
    },
    transport: {
        url: `${ipVariable}/transport`,
        title: "Transport Software Solutions and Services - SPSoft",
        description: "Our Expertise in Transport Industry Software Services offers fully developed Applications for Vehicle Inspection, Trip Inspection, Smart Battery Management, and many others"
    },
    manufacturing: {
        url: `${ipVariable}/manufacturing`,
        title: "Manufacturing Software Services and Solutions - SPSoft",
        description: "We provide manufacturing software development and management services to help manufacturing companies automate workflows and enhance inventory productivity"
    },
    retail: {
        url: `${ipVariable}/retail`,
        title: "Best Retail Software Solutions and Services - SPSoft",
        description: "We offer high-end cost-effective development services for retail operations such as e-commerce application development, service & parts management, and multilingual support that helps redefine customer experiences"
    },
    healthCare: {
        url: `${ipVariable}/healthcare`,
        title: "Healthcare Software Services and Solutions - SPSoft",
        description: "Sp Soft provides health care software services and solutions to you to modernize and scale it up by using technology to deliver better business outcomes"
    },
    telecom: {
        url: `${ipVariable}/telecom`,
        title: "Best Telecom Software Services and Solutions - SPSoft",
        description: "We understand that telecom testing is different from application testing, and we provide comprehensive services for the telecom industry, from early test strategy planning to final validation & maintenance"
    },
    gaming: {
        url: `${ipVariable}/gaming`,
        title: "Online Betting & Entertainment Gaming Software Solutions - SPSoft",
        description: "SPSoft has expertise in designing & deploys gaming software solutions for online entertainment and betting. These include different types of games such as Sportsbooks, Casinos, Racebook, Poker, etc"
    },
    eLearning: {
        url: `${ipVariable}/e-learning`,
        title: "Best E-Learning Software Solutions - SPSoft",
        description: "SP Soft offers custom E-learning software development and management solutions which includes learning management system(LMS) and other research & development information systems"
    },
    capabilities: {
        url: `${ipVariable}/capabilities`,
        title: "Our Core Capabilities For Your Digital Outcomes - SPSoft",
        description: "We offer a wide range of IT-enabled services such as mobile applications development, data analytics, AI & ML solutions, cloud-based applications, manufacturing automation, telecom testing, and workforce solutions"
    },
    expertise: {
        url: `${ipVariable}/expertise`,
        title: "Case Studies | Software Services  - SPSoft",
        description: "Explore our software services and solutions case studies: We have 29 years of experience in different industries such as banking and finance, health care, manufacturing, transport, retail, etc"
    },
    workForceSolutions: {
        url: `${ipVariable}/workforcesolutions`,
        title: "Workforce Recruitment Solutions - SPSoft",
        description: "We have become one of the premier IT Staffing Companies in India. We offer a wide range of workforce recruitment services including Executive Search, Hire, Train and Deploy, Bulk Hiring, Contingent Hiring, and Tech Support Hiring"
    },
    aboutUs: {
        url: `${ipVariable}/about-us`,
        title: "About Us - SPSoft",
        description: "SP Software (P) Limited, a flagship of SP Group, is a leading enterprise business Software and Information Technology (IT) Services company, providing IT Consulting, Technology, and Outsourcing Services"
    },
    reachUs: {
        url: `${ipVariable}/reach-us`,
        title: "Contact Us - SPSoft",
        description: "Please get in touch with us via phone, email, or by filling out the contact form to know more about your reliable IT services provider. We will gladly get back to you as soon as possible!"
    },
    carrer: {
        url: `${ipVariable}/career`,
        title: "Careers - SPSoft",
        description: "Opportunities with SP Soft: If you cannot find a suitable opening please do not worry. We are always up to discovering new talents, Kindly mail us your resume and portfolio link!"
    },
    caseStudy: {
        url: `${ipVariable}/case-study`,
        title: "Customer Case Study | Instant Payments Solutions - SPSoft",
        description: "SP Soft Designed and Developed Web Client an online payment solution that reduces the number of user clicks/user interactions. Need help with a similar project? Let's help you with your queries"
    },
    acdPerformance: {
        url: `${ipVariable}/acdperformance`,
        title: "Developed ACD Performance Reporting and ACD Simulator Solution - SPSoft",
        description: "SP Soft designed and developed ACD performance reporting and ACD simulator solutions. Explore our case study to learn how we overcome the challenge of customers."
    },
    clinicalTrails: {
        url: `${ipVariable}/clinicaltrails`,
        title: "Case Study | Clinical Trials Management Solution - SPSoft",
        description: "SP Soft delivers a web-based clinical trials management solution that works on the go, allowing users to see and manage real-time operational performance at any place and at any point"
    },
    eWallet: {
        url: `${ipVariable}/ewallet`,
        title: "Designed and developed an Email Money Transfer Solution - SPSoft",
        description: "We delivered an Email Money Transfer Solution, which allows users can send money and accept from others through email id and it supports wallet-to-bank account transfer and vice versa"
    },
    aiDigital: {
        url: `${ipVariable}/aidigital`,
        title: "Case Study | AI Digital Classification Solution - SPSoft",
        description: "SP Soft delivers a Digital Classification solution, multiple images of different products, automatically train, and let the user build CNN & YOLO model to perform classification without coding hassle"
    },
    testCaseManagement: {
        url: `${ipVariable}/testcasemanagement`,
        title: "Customer Case Study | Test Case Management - SPSoft",
        description: "We delivered TCM which applies defined sets of rules to standards and client-supplied data to produce outputs according to a defined work process. Let's help you with your queries"
    },
    vehicleInspection: {
        url: `${ipVariable}/vehicleinspection`,
        title: "Case Study | Developed Complete Vehicle Inspection Solution - SPSoft",
        description: "A Driver can perform different TRIP Inspection types for selected vehicle and uploads defective vehicle data symptoms in no time. Need help with a similar project? Let's know your requirements"
    },
    smartHome: {
        url: `${ipVariable}/smarthome`,
        title: "Smart Home Lighting and Admin Application for Android and iOS - SPSoft",
        description: "We designed and developed a Smart Home Lighting app and admin application for Android and iOS. Users can easily organize individual lights into rooms. Let's know if you need help with a similar project"
    },
    onlineGaming: {
        url: `${ipVariable}/onlinegaming`,
        title: "Master Control Panel for Online Gaming Platform | Case Study - SPSoft",
        description: "We developed a cashier, payment gateway server, credit processing server, and gateway management system for the online gaming platform. Explore our case study to learn how we overcome the challenge of customers"
    },
    smartBattery: {
        url: `${ipVariable}/smartbattery`,
        title: "Smart Battery Management App and Admin Application Case Study - SPSoft",
        description: "We delivered a Smart Battery Management app and an Admin application. Users can Analyze and monitor vehicle battery performance by adding assets using Vehicle details. Let's help you with your queries"
    },
    serviceParts: {
        url: `${ipVariable}/serviceparts`,
        title: "Services & Parts Management (SPM) | Case Study - SPSoft",
        description: "We delivered Services & Parts Management (SPM) to the manufacturing company to maintain all aspects of vehicle services, spare parts inventory, manpower, and accounts. Let's help you with your queries"
    },
    contestPlatform: {
        url: `${ipVariable}/contestplatform`,
        title: "Online GameOnEasy Contest Platform | Case Study - SPSoft",
        description: "Online GameOnEasy Contest Platform enables complete control of the customer’s brand with a responsive design that works on the Web, Facebook, Tablets, and Smartphones. Let's help you with your queries"
    },
    enterpriseMobileApp: {
        url: `${ipVariable}/enterprisemobileapp`,
        title: "Enterprise Mobile Application Development Case Study - SPSoft",
        description: "Enterprise Mobile Application enables to Users sign-up and they will become verified members of the Community to chat with other members, comment on listings, and make money selling things they no longer need"
    },
    cropsResearch: {
        url: `${ipVariable}/cropsresearch`,
        title: "Crops Research & Development Information System Case Study - SPSoft",
        description: "We delivered Agricultural Research & Development Information System (EXPLOREit), which enables users can research data based on farming systems, livelihood systems, crops, locations, resource types, and topics"
    },

    aiMlServices: {
        url: `${ipVariable}/ai-ml-services`,
        title: "AI/ML - Artificial Intelligence & Machine Learning Services",
        description: "Discover cutting-edge AI and Machine Learning services tailored to enhance your business. Unlock the potential of technology with our expert solutions."
    },

    dataAnalyticServices: {
        url: `${ipVariable}/data-analytics-services`,
        title: "Data Analytics Services and Solutions",
        description: "Transform your data into actionable insights with our comprehensive analytics services. Elevate your business strategy and achieve measurable results."
    },

    applicationDevelopmentServices: {
        url: `${ipVariable}/application-development-maintenance-services`,
        title: "Application Development & Maintenance (ADM) Services",
        description: "Discover top-notch Application Development & Maintenance (ADM) services tailored to enhance your business efficiency and drive innovation. Partner with us today!"
    },

    webDevelopmentServices: {
        url: `${ipVariable}/web-development-services`,
        title: "Web Development Services Company",
        description: "Experience top-tier web development services that incorporate the most recent tech innovations, ensuring your online presence is both modern and effective."
    },

    testingServices: {
        url: `${ipVariable}/testing-services`,
        title: "Quality Engineering | Software Testing Services and Solutions",
        description: "Elevate your software quality with our comprehensive Quality Engineering and Testing Services. We provide tailored solutions to enhance performance and reliability."
    },

    seoDigitalMarketingServices: {
        url: `${ipVariable}/digital-marketing-services`,
        title: "Digital Marketing Services Company",
        description: "Achieve your marketing goals with our digital services. We offer SEO, Google Ads, and Email Marketing to maximize your reach and engagement"
    },

    OffshoreDevelopmentServices: {
        url: `${ipVariable}/offshore-development-services`,
        title: "Offshore Software Development (ODC) Services",
        description: "We build full-time, dedicated offshore software development teams to handle your unique IT project needs efficiently and professionally."
    },

    PromptEngineeringServices: {
        url: `${ipVariable}/prompt-engineering`,
        title: "Expert Prompt Engineering Services | SP Software (P) Limited",
        description: "Discover the power of prompt engineering with SP Software (P) Limited. Enhance AI accuracy and efficiency through tailored input queries, ensuring optimal performance for your business needs. Learn more about our expert solutions today!"
    },

    AwsServices: {
        url: `${ipVariable}/aws-services`,
        title: "Cost-Effective AWS Solutions | SP Software (P) Limited",
        description: "Unlock the full potential of AWS with SP Software (P) Limited. Our certified AWS services offer competitive rates and expert support for cost optimization, migration, and cloud solutions tailored to your business. Get started now!"
    },

}
